import { recipes, recipeIngredients, recipeResults } from '../data/guide/recipes'
import { nameKey } from './worldFormat'
import type { Material, Recipe, RecipeResult } from '../types/progression'

type Ref = { itemId?: string; gameName?: string; altNames?: string[] }

/**
 * Coincidencia entre un ítem de la ficha y un ingrediente o resultado de receta.
 * Con itemId: coincidencia exacta (una variante como 13,31@0 nunca se confunde con 13,31@1 ni con el base).
 * Sin itemId: por nombre exacto del catálogo o nombre alternativo.
 */
function matches(ref: Ref, id: string, name: string): boolean {
  if (ref.itemId) return ref.itemId === id
  const k = nameKey(name)
  return [ref.gameName, ...(ref.altNames ?? [])].some((n) => n && nameKey(n) === k)
}

/** Recetas cuyo resultado es este ítem o variante. */
export function recipesProducing(id: string, name: string): Recipe[] {
  return recipes.filter((r) => recipeResults(r).some((x: RecipeResult) => matches(x, id, name)))
}

/** Recetas que usan este ítem o variante como ingrediente, con la cantidad de referencia. */
export function recipesUsing(id: string, name: string): { recipe: Recipe; material: Material }[] {
  const out: { recipe: Recipe; material: Material }[] = []
  recipes.forEach((r) => {
    const m = recipeIngredients(r).find((x) => (x.gameName || x.itemId) && matches(x, id, name))
    if (m) out.push({ recipe: r, material: m })
  })
  return out
}
